
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin, CheckCircle, AlertCircle } from 'lucide-react';
import type { LocationData } from '@/hooks/useLocation';

interface LocationStatusProps {
  location: LocationData | null;
  locationError: string | null;
}

const LocationStatus: React.FC<LocationStatusProps> = ({ location, locationError }) => {
  return (
    <Card className="mb-6 border-blue-200 bg-blue-50">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <MapPin className="h-5 w-5 text-gray-600" />
            <span className="text-sm font-medium">Location Services</span>
          </div>
          {location ? (
            <div className="flex items-center text-green-600">
              <CheckCircle className="h-4 w-4 mr-1" />
              <span className="text-sm">Enabled</span>
            </div>
          ) : locationError ? (
            <div className="flex items-center text-red-600">
              <AlertCircle className="h-4 w-4 mr-1" />
              <span className="text-sm">Disabled</span>
            </div>
          ) : (
            <div className="text-sm text-gray-500">Requesting...</div>
          )}
        </div>
        {locationError && (
          <div className="mt-2 text-sm text-red-600">{locationError}</div>
        )}
        {location && (
          <div className="mt-2 text-xs text-gray-500">
            Lat: {location.lat.toFixed(6)}, Lng: {location.lng.toFixed(6)}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LocationStatus;
